import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Configuration } from '../shared-api';
import { HttpClient } from '@angular/common/http';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
  ],
  exports: [
  ]
})
export class SgKdApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<SgKdApiModule> {
    return {
      ngModule: SgKdApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: SgKdApiModule,
    @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('SgKdApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
